import { AUDIT_SYSTEM_ACTOR } from '../../Consts/ops.const';
import { SYSTEM_ROLE_LABEL, SystemRole } from '../../Enums/system-role.enum';
import {
  AuditLogActorResponse,
  AuditLogResponse,
} from '../../Interfaces/api/backoffice/audit-log.interface';

export class AuditLog {
  id = '';
  action: string | null = null;
  entity_type: string | null = null;
  entity_id: string | null = null;
  actor: AuditLogActorResponse | null = null;
  actor_system_role: string | null = null;
  before: Record<string, unknown> | null = null;
  after: Record<string, unknown> | null = null;
  context: Record<string, unknown> | null = null;
  created_at: string | null = null;

  constructor(data: Partial<AuditLogResponse> = {}) {
    Object.assign(this, data);
  }

  get isScheduled(): boolean {
    return this.actor === null;
  }

  get actorLabel(): string {
    return this.actor?.name || this.actor?.email || AUDIT_SYSTEM_ACTOR;
  }

  get roleLabelKey(): string {
    if (this.actor_system_role === null) {
      return '';
    }

    return SYSTEM_ROLE_LABEL[this.actor_system_role as SystemRole] || this.actor_system_role;
  }

  get contextJson(): string {
    return this.context === null ? '' : JSON.stringify(this.context, null, 2);
  }
}
